import { initAnimations } from '../../routes/animationer.js'
import Swiper, { Navigation, A11y } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import { LazyLoadImage } from 'react-lazy-load-image-component';

const Hits = ({ hits, isLoading }) => {
    if (!isLoading && hits.length === 0) {
        return (
            <div className="vehiclesearch-no-results">
                Hittade inga fordon!
            </div>
        );
    } else if(!isLoading) {
        initAnimations();
    }

    Swiper.use([ Navigation, A11y ]);
    initSwiper();

    function initSwiper() {
        document.querySelectorAll('.vehicle-swiper').forEach(vehicle => {
            new Swiper(vehicle, {
                allowTouchMove: true,
                slidesPerView: 1,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                a11y: {
                    prevSlideMessage: 'Föregående bild',
                    nextSlideMessage: 'Nästa bild',
                },
            });
        })
    }

    function formatPrice(price) {
        return Math.round(parseFloat(price)).toLocaleString('sv').replace('−', '− ');
    }

    function getPrice(vehicle) {
        if (vehicle.vehicle_type == "Personbil" && vehicle.price_vat) {
            return vehicle.price_discounted ? vehicle.price_discounted : vehicle.price;
        }
        else if (vehicle.vehicle_type == "Transportbil" && vehicle.price_vat) {
            return vehicle.price_discounted ? vehicle.price_discounted * .8 : vehicle.price * .8;
        }
        else {
            return vehicle.price_discounted ? vehicle.price_discounted : vehicle.price;
        }
    }

    function getPriceMonthly(vehicle) {
        if (vehicle.vehicle_type == "Personbil" && vehicle.price_vat) {
            return vehicle.price_monthly;
        }
        else if (vehicle.vehicle_type == "Transportbil" && vehicle.price_vat) {
            return vehicle.price_monthly * .8;
        }
        else {
            return vehicle.price_monthly;
        }
    }

    function getIsVAT(vehicle) {
        if (vehicle.vehicle_type == "Personbil" && vehicle.price_vat) {
            return "kr/mån";
        }
        else if (vehicle.vehicle_type == "Transportbil" && vehicle.price_vat) {
            return "kr ex. moms";
        }
        else {
            return "kr/mån";
        }
    }

    function getPriceHeading(vehicle) {
        if(vehicle.price_vat && vehicle.vehicle_type == "Transportbil") {
            return 'Pris ex. moms';
        } else if(vehicle.price_discounted) { //  && !vehicle.price_vat
            return <><strike>{formatPrice(vehicle.price)} kr</strike></>;
        }
        return 'Pris'
    }


    return (
        <div className="vehicles_list">
            {hits.map((vehicle) => (
                <a className="vehicles_list__vehicle flex-column-wrapper" data-aos="fade-up" href={vehicle.url}>
                    <div className="img-wrapper">
                        {vehicle.image !== null ? (
                            <div className="swiper vehicle-swiper">
                                <div className="swiper-wrapper">
                                    {
                                        vehicle.images.map((image, key) => {
                                            return (
                                                <div className="swiper-slide" key={key}>
                                                    <LazyLoadImage
                                                      alt={'Bild på ' + vehicle.brand + ' ' + vehicle.model}
                                                      src={image.url}
                                                      srcSet={`${image.url_medium} 320w, ${image.url} 1024w`}
                                                      sizes="(max-width: 600px) 100vw, 320px"
                                                      />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="swiper-controls">
                                    <div className="swiper-button swiper-button-next"></div>
                                    <div className="swiper-button swiper-button-prev"></div>
                                </div>
                            </div>
                        ) : (
                        <>
                            <img loading="lazy" alt={'Platshållarbild för ' + vehicle.brand + ' ' + vehicle.model} src='https://landrinsbil.se/app/themes/landrins-theme/assets/images/noimage.jpg' />
                        </>
                        )}

                        {vehicle.price_discounted ? (
                            <>
                                <div className="discount">{formatPrice(vehicle.price_discounted-vehicle.price)} {vehicle.price_leasing ? 'kr/mån' : 'kr'}</div>
                            </>
                        ) : (
                        <>
                        </>
                        )}
                    </div>
                    <div className="characteristics flex-row-wrapper">
                        {vehicle.gearbox_type === 'Automatisk' ? (
                            <img width="18px" height="18px" loading="lazy" className="icon" alt={vehicle.gearbox_type + ' växellåda'} src="/app/themes/landrins-theme/assets/images/icons/Automat.svg" title={vehicle.gearbox_type + ' växellåda'}/>
                        ) : (
                        <>
                        </>
                        )}
                        {vehicle.gearbox_type === 'Manuell' ? (
                            <img width="18px" height="18px" loading="lazy" className="icon" alt={vehicle.gearbox_type + ' växellåda'} src="/app/themes/landrins-theme/assets/images/icons/Manuell.svg" title={vehicle.gearbox_type + ' växellåda'}/>
                        ) : (
                        <>
                        </>
                        )}
                        {vehicle.fuel_type === 'Diesel' || vehicle.fuel_type === 'Bensin' || vehicle.fuel_type === 'Bensin/etanol' ? (
                            <img width="18px" height="18px" loading="lazy" className="icon" alt={vehicle.fuel_type} src="/app/themes/landrins-theme/assets/images/icons/Diesel-bensin.svg" title={vehicle.fuel_type}/>
                        ) : (
                        <>
                        </>
                        )}
                        {vehicle.fuel_type === 'Hybrid el/bensin' || vehicle.fuel_type === 'Hybrid el/diesel' ? (
                            <img width="32px" height="18px" loading="lazy" className="icon" alt={vehicle.fuel_type} src="/app/themes/landrins-theme/assets/images/icons/Laddhybrid.svg" title={vehicle.fuel_type}/>
                        ) : (
                        <>
                        </>
                        )}
                        {vehicle.fuel_type === 'El' ? (
                            <img width="18px" height="18px" loading="lazy" className="icon" alt={vehicle.fuel_type} src="/app/themes/landrins-theme/assets/images/icons/Elbil.svg" title={vehicle.fuel_type}/>
                        ) : (
                        <>
                        </>
                        )}
                        {vehicle.towbar === '1' ? (
                            <img width="18px" height="18px" loading="lazy" className="icon" alt="Dragkrok" src="/app/themes/landrins-theme/assets/images/icons/Dragkrok.svg" title="Dragkrok"/>
                        ) : (
                        <>
                        </>
                        )}
                        {vehicle.four_wheel_drive === '1' ? (
                            <img width="18px" height="18px" loading="lazy" className="icon" alt="Fyrhjulsdrift" src="/app/themes/landrins-theme/assets/images/icons/Fyrhjulsdrift.svg" title="Fyrhjulsdrift"/>
                        ) : (
                        <>
                        </>
                        )}
                        {vehicle.is_new === '1' ? (
                            <span className="new">Ny</span>
                        ) : (
                        <>
                        </>
                        )}
                        <span className="location" title={vehicle.facility}>{vehicle.facility.replace('Landrins Bil ', '').replace(' 2', '')}<img width="12px" height="18px" loading="lazy" className="icon pin" alt="" src="/app/themes/landrins-theme/assets/images/marker.png" /></span>
                    </div>
                    <strong className="title">{vehicle.brand} {vehicle.model}</strong>
                    <div className="desc">
                        <p className="top">{vehicle.model_description}</p>
                        <div className="attributes flex-row-wrapper">
                            <span className="attributes__attr">{vehicle.model_year}</span>
                            {vehicle.vehicle_type === 'Husvagn' ? (
                                <>
                                    {vehicle.beds && vehicle.beds !== "" && vehicle.beds != "0" ? (
                                        <>
                                            •
                                            <span className="attributes__attr">{vehicle.beds} bäddar</span>
                                        </>
                                    ) : (
                                        <>
                                        </>
                                    )}
                                    {vehicle.length && vehicle.length !== "" && vehicle.length != "0" ? (
                                        <>
                                            •
                                            <span className="attributes__attr">{vehicle.length}m lång</span>
                                        </>
                                    ) : (
                                        <>
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <span className="attributes__attr">{vehicle.miles} mil</span>
                                    {vehicle.fuel_type.toLowerCase() ? (
                                        <>
                                            •
                                            <span className="attributes__attr">{vehicle.fuel_type}</span>
                                        </>
                                    ) : (
                                        <>
                                        </>
                                    )}
                                    {vehicle.fuel_type.toLowerCase() != 'hybrid el/bensin' && vehicle.fuel_type.toLowerCase() != 'hybrid el/diesel' ? (
                                        <>
                                            •
                                            <span className="attributes__attr">{vehicle.gearbox_type}</span>
                                        </>
                                    ) : (
                                    <>
                                    </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <div className="price flex-row-wrapper">
                        {vehicle.price_leasing ? (
                        <>
                            <div>
                                <p className="text">Privatleasing från</p>
                                <strong className="price-text">{formatPrice(vehicle.price_discounted ? vehicle.price_discounted : vehicle.price)} kr/mån</strong>
                            </div>
                        </>
                        ) : (
                        <>
                            {vehicle.auction === '0' ? (
                            <>
                                {getPrice(vehicle) ? (
                                <>
                                    <div className="type">
                                        <p className="text">{getPriceHeading(vehicle)}</p>
                                        <strong className={vehicle.price_changed ? 'price-text price-text--discounted' : 'price-text'}>{formatPrice(getPrice(vehicle))} kr</strong><br />
                                    </div>
                                </>
                                ) : (
                                <>
                                </>
                                )}

                                {getPriceMonthly(vehicle) ? (
                                <>
                                    <div className="type">
                                        <p className="text">{vehicle.price_vat ? 'Månadskostnad' : 'Finansiering'} från</p>
                                        <strong className="price-text price-text--white">{formatPrice(getPriceMonthly(vehicle))} {getIsVAT(vehicle)}</strong>
                                    </div>
                                </>
                                ) : (
                                <>
                                </>
                                )}
                            </>
                            ) : (
                            <>
                                <div className="type">
                                    <p className="text">Aktuellt bud</p>
                                    <strong className="price-text">{formatPrice(getPrice(vehicle))} kr</strong><br />
                                </div>
                            </>
                            )}
                        </>
                        )}
                    </div>
                </a>
            ))}
        </div>
    );
}

export default Hits



